import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "module_nav" }
const _hoisted_2 = ["onClick", "data-module", "id"]

import { modules } from "@/busData";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function pillNav(item: string) {
  let pillWrapper = document.querySelector(`.${item}-container`);
  pillWrapper?.scrollIntoView({ behavior: 'smooth' });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modules), (item) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "pill nav-item",
        onClick: ($event: any) => (pillNav(item)),
        key: item,
        "data-module": item.toString().toLowerCase(),
        id: item
      }, _toDisplayString(item), 9, _hoisted_2))
    }), 128))
  ]))
}
}

})